import { Controller } from "stimulus"

export default class extends Controller {

    toggle(e) {
        document.querySelector('.nav').classList.toggle('open-nav');
    }
}